module.exports = __webpack_public_path__ + "static/img/stair-Img.1783997848725.png";